import request from '@/utils/request'
import { menuCodeHeaders, ScheduleMenuCode } from '@/utils/menuCodeHeaders'
import {
  CreateCutOffScheduleReq,
  DeleteCutOffScheduleReq,
  GetSchedulesGridReq,
  GetSchedulesGridRes,
  GetOverseasPriorityRes,
  SetPriorityTypeReq,
  SetOverseasPriorityReq,
  UpdateScheduleStatusV2Req,
  UpdateSlotWaitTimeReq,
  UpsertGlobalCuttimeReq,
} from './types'

/** 일자별 출고 일정 조회 (v2) */
export const getOutboundSchedules = (params: GetSchedulesGridReq) =>
  request.post<ApiResponseV2<GetSchedulesGridRes>, GetSchedulesGridReq>('/api/v2/get-schedules-grid', params)

/** 출고지시 on/off 토글 (v2) — (시간대 × 센터) is_enabled 업서트 */
export const updateScheduleStatus = (params: UpdateScheduleStatusV2Req) =>
  request.post<ApiResponseV2<null>, UpdateScheduleStatusV2Req>('/api/v2/update-schedule-status', params)

/** 컷오프 일정 생성  */
export const createCutOffSchedule = (params: CreateCutOffScheduleReq) => request.post('/api/v1/create-schedule', params)

/** 컷오프 일정 삭제 */
export const deleteCutOffSchedule = (params: DeleteCutOffScheduleReq) => request.post('/api/v1/delete-schedule', params)

/** 할당 우선순위 설정 (v2, D-12) — priority_type + warehouse priority 통합 세팅 */
export const setPriorityType = (params: SetPriorityTypeReq) =>
  request.post<ApiResponseV2<null>, SetPriorityTypeReq>('/api/v1/set-priority-type', params)

// 해외 우선순위 API 는 gi27·gi28 이 같이 부른다 — 부른 화면코드를 헤더로 보내 감사 로그 MENU_CD 를 가른다(LOGISPRD-15645)
/** 해외 출고 우선순위 조회 */
export const getOverseasPriority = (menuCode: ScheduleMenuCode) =>
  request.post<ApiResponseV2<GetOverseasPriorityRes>>('/api/v1/get-overseas-priority', {}, menuCodeHeaders(menuCode))

/** 해외 출고 우선순위 설정 */
export const setOverseasPriority = (params: SetOverseasPriorityReq, menuCode: ScheduleMenuCode) =>
  request.post('/api/v1/set-overseas-priority', params, menuCodeHeaders(menuCode))

/** 시간대별 Wait Time 설정 (v2) — wait_time + priority_type 슬롯 단위 upsert */
export const updateSlotWaitTime = (params: UpdateSlotWaitTimeReq) =>
  request.post<ApiResponseV2<null>, UpdateSlotWaitTimeReq>('/api/v1/update-slot-wait-time', params)

/** 컷 마감시간 설정 (v2) — global cut time(cutTime + isEnabled) upsert */
export const upsertGlobalCuttime = (params: UpsertGlobalCuttimeReq) =>
  request.post<ApiResponseV2<null>, UpsertGlobalCuttimeReq>('/api/v1/upsert-global-cuttime', params)
